import React, { useState, useRef } from 'react';
import { TilingSprite, useTick } from '@inlet/react-pixi';

const ScrollingImage = ({...props}) => {
  const [{ tilePosition }, setTile] = useState({
    tilePosition: { x: 0, y: 0 }
  });

  const i = useRef(0);
  

  useTick((delta) => {
    i.current += delta * 0.005;

    if(props.goRight){
        setTile(({ tilePosition }) => ({
            tilePosition: {
                x: tilePosition.x + props.xDelta,
                y: tilePosition.y
            }
        }));
    }
    else{
        setTile(({ tilePosition }) => ({
            tilePosition: {
                x: tilePosition.x - props.xDelta,
                y: tilePosition.y
            }
        }));
    }
  });

  return (
    <TilingSprite
      image={props.tileImage}
      width={props.width}
      height={props.height}
      tilePosition={tilePosition}
      scale={props.scale}
      x={props.x}
      y={props.y}
      alpha={props.alpha}
    />
  );
};

export default ScrollingImage;